<template lang="pug">
  div
    section.header
      h2 3. Identificación de bien contratado
      p
        span Por favor ingrese los datos del producto o servicio que contrató con nosotros
      hr

    .tipo-empresa-container(
      key="tipo-empresa"
    )
      label.label Seleccione el tipo de bien contratado
      div.select-box
        .option.bd-color-empresa(
          v-for="o in tipos"
          :class="{ 'bg-empresa': bien.tipo === o.tipo }"
          @click="seleccionarTipo(o)"
        )
          i.fa(:class="o.clase")
          span {{ o.descripcion }}
      div
        .field
          label.label Monto reclamado
          .control
            input.input(type='number', v-model="bien.monto", @blur="sendData()")
            .little-option.bd-color-empresa(
              v-for="o in monedas"
              :class="{ 'bg-empresa': bien.moneda === o.codigo }"
              @click="seleccionarMoneda(o)"
            )
              span {{ o.descripcion }}
            
        .field
          label.label Descripción
          .control
            input.input(type='text', v-model="bien.descripcion", @blur="sendData")

</template>
<script>
export default {
  name: 'box-identificacion-bien-contratado',
  data () {
    return {
      bien: {
        tipo: '',
        moneda: 'soles',
        monto: '',
        descripcion: ''
      },
      tipos: [
        {tipo: 'producto', descripcion: 'Producto', clase: 'fa-print'},
        {tipo: 'servicio', descripcion: 'Servicio', clase: 'fa-handshake-o'}
      ],
      monedas: [
        {codigo: 'soles', descripcion: 'S/'},
        {codigo: 'dolares', descripcion: '$'}
      ]
    }
  },
  created () {

  },
  methods: {
    sendData () {
      this.$emit('send', this.bien)
    },
    seleccionarTipo (o) {
      this.bien.tipo = o.tipo
      this.sendData()
    },
    seleccionarMoneda (o) {
      this.bien.moneda = o.codigo
      this.sendData()
    },
    clean () {
      this.bien = {
        tipo: '',
        moneda: 'soles',
        monto: '',
        descripcion: ''
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
  .control
    flex 1
    display flex
    input
      font-size 14px
      height 25px
  
  .select-box
    align-items center
    justify-content center
    .option
      max-width: 100px;
      text-align center
  
  .little-option
    cursor pointer
    border 1px solid #ccc
    padding 2px 10px 1px 10px
    margin-left 5px
    transition all ease 0.3s
    border-radius 3px
    text-align center
    font-size 13px
    &:hover
      background-color #eae8e8
  
</style>



// WEBPACK FOOTER //
// Box-3-identificacion-bien-contratado.vue?0911e311